import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';

/**
 * @class PaymentOption
 * @property {integer} id
 * @property {Property} property
 * @property {string} name
 * @property {string} name_ar
 * @property {integer} type
 * @property {integer} status
 * @property {string} payment_method_internal
 */
export class PaymentOption extends TranslatableModel {

}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'name_ar',
    'type',
    'model',
    'status',
    'payment_method_internal',
)(PaymentOption);



// WEBPACK FOOTER //
// ./src/pms-api/models/payment-option.model.js